<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">External Provider Management</h2>
    </div>
    <form class="needs-validation px-2 pt-2" >
      <div class="form-group row mx-0 justify-content-end" :style="{ marginBottom: '1rem' }">

          <div class=" my-2 ">
          <button
              title="Add new"
              class="k-button k-secondary"
              @click="insert"
              type="button"
            >
              <i class="fa fa-plus mr-2" aria-hidden="true"></i>

              Add new
          </button>
        </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="providers">
      <Grid
        ref="grid"
        :style="{ height: '55vh' }"
        :pageable="true"
        :skip= "skip"
        :data-items="result"
        :columns="columns"
        :take="take"
        :total="total"
        @pagechange="pageChangeHandler"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>
        <grid-toolbar class="text-left">
        </grid-toolbar>
        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="externalProviderInEdit"
        :dialog-title="dialogTitle"
        :providerTypes="providerTypes"
        :data-item="externalProviderInEdit"
        @save="save"
        @cancel="cancel"
      >
      </dialog-container>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import DialogContainer from "./DialogContainer";
import CommandCell from "./CommandCell";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../../services/store";

export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    dropdownlist: DropDownList,
  },
  props: {
    identity: {
      type: Object,
      default: null,
    }
  },
  data: function () {
    return {
      base_url: undefined,
      sort: [{ field: "id", dir: "asc" }],
      externalProviderInEdit:undefined,
      providers:undefined,
      providerTypes:undefined,
      tenants: [],
      selectedIdentity: this.identity,
      skip: 0,
      take: 10,
      columns: [
        {
          field: "displayName",
          title: "External Provider Name",
          width: "150px",
        },
        { field: "fields", title: "Fields"},

        { field: "predefinedType", title: "Predefined Type", },

        { field: "type", title: "Type",},
        
        { field: "imgUrl", title: "Img Url",},

      ],
    };
  },
  computed: {
    dialogTitle() {
      return `${this.externalProviderInEdit.type === undefined ? "Add" : "Edit"} External Provider`;
    },
    result: {
            get: function() {
                return this.providers.slice(this.skip, this.take + this.skip);
            }
        },
    total () {
        return this.providers ? this.providers.length : 0;
    }
  },
  mounted: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    this.getProviders();
    this.getProviderTypes();
  },
  watch:{
    identity:function(){
      this.selectedIdentity=this.identity;
    }
  },
  methods: {
    pageChangeHandler: function(event) {
            this.skip = event.page.skip;
            this.take = event.page.take;
        },
    async getProviders() {
      try {
        const response = await axios.get(this.base_url + "ExternalProvider/GetAllExternalProviders");
        this.providers = response.data.result;
        console.log(response.data.message);
      } catch (err) {
        console.log(err);
      }
    },
    async getProviderTypes() {
      try {
        const response = await axios.get(this.base_url + "ExternalProvider/GetProviderTypes");
        this.providerTypes = response.data.result;
        console.log(response.data.message);
      } catch (err) {
        console.log(err);
      }
    },
    edit(dataItem) {
      this.externalProviderInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      try {
        //const response = await axios.post("https://localhost:5001/api/User/AddUser", data);

        const response = await axios.delete(this.base_url + "ExternalProvider/DeleteExternalAuthProvider/"+
            dataItem.externalProviderID +"/"+
            this.selectedIdentity.id
         );
        this.status = response.data.status;
        this.responseMsg = response.data.message;
        this.showMsg = true;
        this.userData = {};
        //this.$router.push("/home");
        this.providers = this.providers.filter((p) => p.externalProviderID !== dataItem.externalProviderID);
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    async save(){
      const dataItem = this.externalProviderInEdit;
      let data = {
        Name: dataItem.name,
        DisplayName: dataItem.displayName,
        PredefinedType: dataItem.predefinedType,
      };
        try {
          const formData = new FormData();
          formData.append("file", dataItem.logo);
          const response = await axios
            .post(this.base_url + "ExternalProvider/AddExternalProvider/"+dataItem.name+"/"+dataItem.displayName+"/"+dataItem.predefinedType,
             formData, {
        header: {
          "Content-Type": "multipart/form-data",
        }}).then((res)=>{
          var newObject = res.data.result;
          this.providers.push(newObject);
        });
          this.status = response.data.status;
          this.responseMsg = response.data.message;
          this.showMsg = true;
          this.userData = {};
          //this.$router.push("/home");
        } catch (err) {
          console.log("Ooops!" + err);
        }
      this.externalProviderInEdit = undefined;
    },
    cancel() {
      this.externalProviderInEdit = undefined;
    },
    insert(){
      this.externalProviderInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}

.needs-validation {
  background: white;
}
</style>